import { RichTextEditor } from '../ui/RichTextEditor';

interface SummarySectionProps {
    summary?: string;
    onChange: (summary: string) => void;
    onOptimize: (summary: string) => void;
    isOptimizing?: boolean;
}

export function SummarySection({ summary, onChange, onOptimize, isOptimizing = false }: SummarySectionProps) {
    return (
        <div className="card">
            <div className="flex items-center justify-between mb-2">
                <h2 className="section-title mb-0">Professional Summary</h2>
                <button
                    type="button"
                    className="btn btn-secondary text-sm"
                    disabled={isOptimizing}
                    onClick={() => onOptimize(summary || '')}
                >
                    {isOptimizing ? 'Optimizing...' : 'Optimize with AI'}
                </button>
            </div>
            <RichTextEditor
                value={summary || ''}
                onChange={onChange}
                className="mb-2"
                minHeight="120px"
                placeholder="Brief overview of your professional background and key qualifications..."
            />
        </div>
    );
}
